import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios';
import Select, { components } from "react-select";
import { toast } from 'react-toastify'; 
import bgimage from '../../../../images/items/items.jpg';

const AddChecklist = ({ show, onClose, data, onSuccess }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [checklist, setChecklist] = useState([{ id: Date.now(), quality_name: '', priority_sno: null }]);
  const [errors, setErrors] = useState({});
  const [priorityOptions, setPriorityOptions] = useState([]);

  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const res = await axios.get(`${baseURL}/manage-priorities/active/list`);
        if (res.status === 200) {
          const formatted = res.data.data.map(p => ({
            value: p.sno,
            label: p.priority_name,
          }));
          setPriorityOptions(formatted);
        }
      } catch (err) {
        console.error("Failed to fetch priorities", err);
      }
    };

    if (show) fetchPriorities();
  }, [show, baseURL]);

  // FIXED: Map API response correctly to local state keys
  useEffect(() => {
    if (data?.item_quality) {
      setChecklist(data.item_quality.map((q, index) => ({
        id: q.id || Date.now() + index,
        quality_name: q.quality_name || '',
        priority_sno: q.priority_id || null,  // <-- Use priority_id here
      })));
    }
  }, [data]);

  const handleInputChange = (id, field, value) => {
    setChecklist(prev =>
      prev.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );

    setErrors(prev => {
      const updated = { ...prev };
      if (updated[id]) {
        delete updated[id][field];
        if (Object.keys(updated[id]).length === 0) delete updated[id];
      }
      return updated;
    });
  };

  const handleAddConfig = () => {
    setChecklist([...checklist, { id: Date.now(), quality_name: '', priority_sno: null }]);
  };

  const handleDeleteConfig = id => {
    setChecklist(prev => prev.filter(item => item.id !== id));
    setErrors(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const handleSubmit = async () => {
    const newErrors = {};

    checklist.forEach(item => {
      const fieldErrors = {};
      if (!item.quality_name.trim()) {
        fieldErrors.quality_name = 'Item quality is required';
      }
      if (item.priority_sno === null) {
        fieldErrors.priority_sno = 'Priority is required';
      }
      if (Object.keys(fieldErrors).length > 0) {
        newErrors[item.id] = fieldErrors;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!data?.sno) return;

    try {
      const res = await axios.post(`${baseURL}/manage-items/quality/${data.sno}`, {
        item_quality: checklist.map(({ quality_name, priority_sno }) => ({
          quality_name,
          priority_id: priority_sno, // correct field for API
        })),
      });

      if (res.status === 200 && res.data?.data?.item_quality) {
        // FIXED: Map returned data to local state correctly
        setChecklist(res.data.data.item_quality.map((q, i) => ({
          id: q.id || Date.now() + i,
          quality_name: q.quality_name || '',
          priority_sno: q.priority_id || null,
        })));
      }

       toast.success("Item Checklist Created Successfully!");
                  if (onSuccess) onSuccess();
                  onClose();

      // onClose();
    } catch (err) {
      console.error("Error updating item quality:", err);
    }
  };

  const Group = props => (
    <div style={customStyles}>
      <components.Group {...props} />
    </div>
  );

  const customStyles = {
    groupHeading: provided => ({
      ...provided,
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#333',
    })
  };

  const onInit = () => {};

  return (
    <Modal show={show} size="lg" onHide={onClose}>
      <div className="modal-content border rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Quality Checklist</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row mb-3">
            <div className="col-lg-12 d-flex gap-2 align-items-center">
              <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                <div data-src={data?.item_image || bgimage} className='border rounded px-1 py-0'>
                  <img src={data?.item_image || bgimage} alt={data?.item_name} className='cursor-pointer w-60px h-60px' />
                </div>
              </LightGallery>
              <div>
                <span className='fs-5'>{data?.item_name}</span> | <span className='fs-5'>{data?.itemcategory_name}</span> | <span className='fs-5'>{data?.itemsubcategory_name}</span>
                <div className='mt-1'>
                  <Badge bg="warning" className='fs-7 py-0 px-1'>{data?.catering_corp_quantity} {data?.catering_corp_unit_slug_name}</Badge>{' '}
                  {/* <Badge bg="success" className='fs-7 py-0 px-1'>{data?.item_weight} {data?.item_unit_slug_name}</Badge>{' '} */}
                  {/* <Badge bg="info" className='fs-7 py-0 px-1'>{data?.item_size} {data?.slug_name}</Badge> */}

                  {data?.item_weight && data?.item_unit_slug_name && (
                    <Badge bg="success" className="fs-7 py-0 px-1">
                      {data.item_weight} {data.item_unit_slug_name}
                    </Badge>
                  )} 

                  {data?.item_size && data?.slug_name && (
                    <Badge bg="info" className="fs-7 py-0 px-1">
                      {data.item_size} {data.slug_name}
                    </Badge>
                  )}


                </div>
              </div>
            </div>
          </div>     

          <div className='row'>
            <div className='scroll-y mh-350px py-2'>
              {checklist.map(config => (
                <div key={config.id} className="row mb-3 align-items-end">
                  <div className="col-lg-5">
                    <label>Item Quality<span className="required">*</span></label>
                    <input
                      type="text"
                      className={`form-control ${errors[config.id]?.quality_name ? 'is-invalid' : ''}`}
                      placeholder="Enter Item Quality"
                      value={config.quality_name}
                      onChange={e => handleInputChange(config.id, 'quality_name', e.target.value)}
                    />
                    {errors[config.id]?.quality_name && <span className="text-danger small">{errors[config.id].quality_name}</span>}
                  </div>

                  <div className="col-lg-5">
                    <label>Priority<span className="required">*</span></label>
                    <Select
                      placeholder="Select Priority"
                      options={priorityOptions}
                      value={priorityOptions.find(o => o.value === config.priority_sno) || null}
                      onChange={sel => handleInputChange(config.id, 'priority_sno', sel?.value)}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      menuPortalTarget={document.body}
                      components={{ Group }}
                      menuPosition="fixed"
                      className={errors[config.id]?.priority_sno ? 'is-invalid' : ''}
                    />
                    {errors[config.id]?.priority_sno && <span className="text-danger small">{errors[config.id].priority_sno}</span>}
                  </div>

                  <div className="col-lg-1">
                    {checklist.length > 1 && (
                      <Button variant="danger" onClick={() => handleDeleteConfig(config.id)} className="mt-2 px-2 py-1">
                        <i className="fa-solid fa-trash-can text-white"></i>
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="mb-1">
              <Button size="sm" onClick={handleAddConfig}>
                <i className="fa-solid fa-plus"></i> Add More
              </Button>
            </div>
          </div>  

          


          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <Button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
              {data?.item_quality ? 'Update' : 'Create'} Quality Checklist  <i className="fas fa-angle-double-right ms-2"></i>
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddChecklist;
  